export default {
  'search.placeholder': 'Please enter ID or keyword for help',
  'search.result': 'Search for "{search}", {number} results found.',
  'no.search.results': 'No search results.',
  'email.to.us': 'Send this question to us.',
  'copy.success': 'Copy successful!',
  'copy.link': 'Copy Link'
}
